import React from "react";
import PropTypes from "prop-types";

import { formatLongDate } from "lib/format";

/**
 * Default date component
 * props -
 * date: must be a moment.js-parsable date. String or object is standard!
 *
 */
export default class Date extends React.PureComponent {
  static propTypes = {
    date: PropTypes.any.isRequired
  }
  
  render() {
    const formattedDate = formatLongDate(this.props.date);
    return formattedDate;
  }
  
}



// WEBPACK FOOTER //
// ./src/components/Date.js